import { render, staticRenderFns } from "./profession_view.vue?vue&type=template&id=617af6dd&"
import script from "./profession_view.vue?vue&type=script&lang=js&"
export * from "./profession_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports